// extracted by mini-css-extract-plugin
export default {"OverviewWrapper":"Overview_OverviewWrapper__C7dUi","InnerDiv":"Overview_InnerDiv__U3c9Y"};